const SmartTableLoadingShell = () => (
  <div className="flex h-full flex-1 flex-col overflow-hidden">
    <div className="relative min-h-0 flex-1 overflow-hidden bg-background">
      <div className="flex h-full flex-col">
        <div className="flex items-center gap-2 border-b border-border/50 px-4 py-2">
          <div className="h-4 w-24 rounded bg-muted/50" />
          <div className="h-4 w-16 rounded bg-muted/40" />
        </div>
        <div className="min-h-0 flex-1 px-4 py-3">
          <div className="h-full rounded-md border border-border/60 bg-muted/20" />
        </div>
      </div>
    </div>

    <div className="flex-shrink-0 pt-0.5 backdrop-blur">
      <div className="flex items-center gap-1">
        <div className="flex h-9 w-40 items-center rounded-lg bg-muted/50 px-1 py-1 shadow-sm" />
        <div className="h-9 w-9 rounded-md bg-muted/40" />
      </div>
    </div>
  </div>
);

export default SmartTableLoadingShell;
